<template>
  <section id="searchBrand" ref="searchBrand">
    <GarageBrand :brand_name="brand" :brand_id="carBrandId" :color_kv="color"></GarageBrand>
    <div hidden>KIA Pre-owned Cars</div>
  </section>
</template>

<script>
import GarageBrand from '../components/GarageBrand'

let vm = null
export default {
  metaInfo: {
    title: 'Kia Pre-owned Cars', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'Kia Pre-owned Cars'
    },
    {
      name: 'description',
      content: 'Kia Pre-owned Cars – Buy premium condition pre-owned cars with warranty.'
    }]
  },
  name: "KIA",
  data() {
    return {
      metaData: 'Kia Pre-owned Cars',
      carBrandId: 19,
      brand: 'Kia',
      color: '#05141f',
      favicon: '/favicon_Kia.ico'
    };
  },
  created() {
  },
  async mounted() {
    this.setFavicon()
  },
  beforeDestroy() {
    this.resetFavicon()
  },
  methods: {
    setFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = this.favicon
      }
    },
    resetFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = '/favicon.ico'
      }
    }
  },
  components: {
    GarageBrand
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/Kia.vue